export default {"src":"/_next/static/media/nobitex.32bc5f77.svg","height":85,"width":512,"blurWidth":0,"blurHeight":0};